import { Button, Flex, Text } from '@radix-ui/themes';
import { MlbStatsHelper } from 'classes/helpers/mlb-stats.helper';
import { PitchDesignHelper } from 'classes/helpers/pitch-design.helper';
import { CommonCallout } from 'components/common/callouts';
import { AddAveragesIcon } from 'components/common/custom-icon/shorthands';
import { ErrorBoundary } from 'components/common/error-boundary';
import { CommonTooltip } from 'components/common/tooltip';
import { GameDataContext } from 'contexts/game-data.context';
import { t } from 'i18next';
import { IRepertoire } from 'interfaces/i-mlb-browse';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { IMlbPitchExt } from 'lib_ts/interfaces/mlb-stats-api/i-pitch';
import { IMlbPlayer } from 'lib_ts/interfaces/mlb-stats-api/i-player';
import { useContext, useMemo } from 'react';

export const GameDataPitcherRepertoire = (props: {
  pitcher: IMlbPlayer;
  pitches: IMlbPitchExt[];
}) => {
  const { openImportPitchersDialog } = useContext(GameDataContext);

  const repertoire: IRepertoire[] = useMemo(
    () => MlbStatsHelper.getRepertoire(props.pitches),
    [props.pitches]
  );

  return (
    <ErrorBoundary identifier="GameDataPitcherRepertoire">
      <Flex p="2" gap="4" direction="column" align="end">
        {repertoire.length === 0 && (
          <CommonCallout text="common.no-results-found" />
        )}

        {repertoire.length > 0 && (
          <table style={{ borderSpacing: '8px 4px' }}>
            <tbody>
              <tr>
                <td>&nbsp;</td>
                <td>
                  <Text size="1" color={RADIX.COLOR.SECONDARY}>
                    Usage <sub>%</sub>
                  </Text>
                </td>
                <td>
                  <Text size="1" color={RADIX.COLOR.SECONDARY}>
                    Vel. <sub>mph</sub>
                  </Text>
                </td>
                <td>
                  <Text size="1" color={RADIX.COLOR.SECONDARY}>
                    VB <sub>in</sub>
                  </Text>
                </td>
                <td>
                  <Text size="1" color={RADIX.COLOR.SECONDARY}>
                    HB <sub>in</sub>
                  </Text>
                </td>
              </tr>

              {repertoire.map((m, i) => (
                <tr key={i}>
                  <td>
                    <Text size="1">{m.type}</Text>
                  </td>
                  <td align="right">
                    <Text size="1">{m.usage.toFixed(1)}</Text>
                  </td>
                  <td align="right">
                    <Text size="1">{m.speedMPH.toFixed(1)}</Text>
                  </td>
                  <td align="right">
                    <Text size="1">{m.breaks.zInches.toFixed(1)}</Text>
                  </td>
                  <td align="right">
                    <CommonTooltip
                      text={PitchDesignHelper.HB_TOOLTIP_TEXT}
                      trigger={
                        <Text size="1">{(-m.breaks.xInches).toFixed(1)}</Text>
                      }
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        <Button
          variant={RADIX.BUTTON.VARIANT.SECONDARY}
          onClick={() => openImportPitchersDialog([props.pitcher])}
        >
          <AddAveragesIcon /> {t('pd.add-averages-to-pitch-list')}
        </Button>
      </Flex>
    </ErrorBoundary>
  );
};
